// Global feature flags for billing/premium behavior
// Toggle these to re-enable Stripe later without losing code.
export const ALWAYS_PREMIUM = false; // Set all users as premium by default (DISABLED - users must pay for premium)
export const ENABLE_BILLING_UI = true; // Enable upgrade flows for premium subscription

